import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const equipmentAssignList = createAsyncThunk('equipmentAssignList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `equipment_assignment`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'department_id': data?.department_id,
                'location_id': data?.location_id,
                'component_id': data?.component_id,
                'equipment_id': data?.equipment_id,
                'part_number': data?.part_number,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const equipmentAssignListSlice = createSlice({
    name: 'equipmentAssignList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(equipmentAssignList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(equipmentAssignList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default equipmentAssignListSlice.reducer;